// Beschriftungen für Status und Priorität – an EINER Stelle, damit Zeitleiste
// und Detailfenster nicht auseinanderlaufen.

import type { Prioritaet, Status } from "./planner";

export const STATUS_TEXT: Record<Status, string> = {
  offen: "Offen",
  aktiv: "In Bearbeitung",
  erledigt: "Erledigt",
};

/** Kurzzeichen in der Aufgabenspalte; „mittel“ ist die Voreinstellung und bleibt stumm. */
export const PRIO_ZEICHEN: Record<Prioritaet, string> = {
  dringend: "‼",
  wichtig: "!",
  mittel: "",
  niedrig: "↓",
};

export const PRIO_TEXT: Record<Prioritaet, string> = {
  dringend: "Dringend",
  wichtig: "Wichtig",
  mittel: "Mittel",
  niedrig: "Niedrig",
};
